
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M27.6 11.6V1.5h-5.8v4.4L16 0 0 16h2.9v16h8.7V18.9h8.7V32H29V16h3l-4.4-4.4z"}})])
      }
    
      }
    